module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00711.f073ceed.jpg";